import { faStar, faStarHalf } from '@fortawesome/duotone-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FC } from 'react';
import './StarSymbols.scss';

interface Props {
  rating: number;
}

export const StarSymbols: FC<Props> = ({ rating }) => {
  const floored = Math.floor(rating);
  const rest = rating - floored;
  const stars = [...new Array<null>(floored)].map(() => (
    <span className={'icon rating-star-icon'}>
      <FontAwesomeIcon icon={faStar} color={'#e5a50a'} />
    </span>
  ));
  if (rest > 0.25 && rest <= 0.75) {
    stars.push(
      <span className={'icon rating-half-star-icon'}>
        <FontAwesomeIcon icon={faStarHalf} color={'#e5a50a'} />
      </span>,
    );
  } else if (rest > 0.75) {
    stars.push(
      <span className={'icon rating-star-icon'}>
        <FontAwesomeIcon icon={faStar} color={'#e5a50a'} />
      </span>,
    );
  }
  return <>{...stars}</>;
};
StarSymbols.displayName = 'StarSymbols';
